import React, { useState, useEffect } from "react";
import styles from "../addCategoryForm/addCategoryForm.module.css";
import { Add, Delete } from "../../Svg";
import { useSelector } from "react-redux";



const VariantsCard = ({ setFieldValue, values, errors, touched, handleBlur }) => {

    const { atributes } = useSelector((state) => state.products);
    const { exportedData } = useSelector((state) => state.manufacturer);
    const manufacturer = Array.isArray(exportedData) ? exportedData : (Array.isArray(exportedData?.data) ? exportedData.data : []);
    const attributeOptions = atributes.attributeOptions
    const valueOptions = atributes.valueOptions

    const [attributes, setAttributes] = useState([
        { type: "", values: [] },
    ]);
    const [isOpen, setIsOpen] = useState(null);


    useEffect(() => {
        if (values.attributes && typeof values.attributes === 'object') {
            const formattedAttributes = Object.entries(values.attributes)
                .filter(([key]) => key && key.trim() !== '')
                .map(([key, value]) => {
                    let valArr = [];
                    if (Array.isArray(value)) {
                        valArr = value;
                    } else if (value !== undefined && value !== null && value !== '') {
                        valArr = [String(value)];
                    }
                    return {
                        type: key,
                        values: valArr
                    };
                });
            setAttributes(formattedAttributes.length ? formattedAttributes : [{ type: "", values: [] }]);
        }
    }, [values.attributes]);


    const handleAttributeTypeChange = (index, newType) => {
        setAttributes((prev) => {
            const updatedAttributes = [...prev];
            let initialValues = [];
            if (newType && newType.trim().toLowerCase() === "manufacturer") {
                const selectedMfgId = values?.productOverview?.manufacturer?.[0];
                const selectedMfg = manufacturer?.find(m => m?._id?.toString() === selectedMfgId?.toString());
                if (selectedMfg?.name) {
                    initialValues = [selectedMfg.name];
                }
            }
            updatedAttributes[index] = { type: newType, values: initialValues };


            const updatedFormikAttributes = Object.fromEntries(updatedAttributes?.map(attr => [attr.type, attr.values]));
            setFieldValue("attributes", updatedFormikAttributes);

            return updatedAttributes;
        });
    };


    const handleValueChange = (index, value) => {
        setAttributes((prev) => {
            const updatedAttributes = [...prev];

            updatedAttributes[index].values = [value];


            const updatedFormikAttributes = Object.fromEntries(updatedAttributes?.map(attr => [attr.type, attr.values]));
            setFieldValue("attributes", updatedFormikAttributes);

            return updatedAttributes;
        });
    };


    const handleAddAttribute = () => {
        setAttributes([...attributes, { type: "", values: [] }]);
    };

    const handleRemoveAttribute = (index) => {
        setAttributes((prev) => {
            const updatedAttributes = prev.filter((_, i) => i !== index);


            const updatedFormikAttributes = Object.fromEntries(updatedAttributes?.map(attr => [attr.type, attr.values]));
            setFieldValue("attributes", updatedFormikAttributes);

            return updatedAttributes;
        });
    };

    return (
        <div className={styles.formSection}>
            <div className={styles.card}>
                <h2 className={styles.addCatH2}>Attributes</h2>
                {errors.attributes && touched.attributes && (
                    <p className={styles.errorText}>{errors.attributes}</p>
                )}
                {attributes?.map((attr, index) => (
                    <div key={index} className={styles.variantContainer}>

                        <label className={styles.addCatLabel} style={{ width: "50%" }}>
                            Variation Type
                            <select
                                className={styles.addCatSelect}
                                value={attr.type}
                                onChange={(e) => handleAttributeTypeChange(index, e.target.value)}
                                onBlur={handleBlur}
                            >
                                <option value="">Select</option>
                                {attr.type && !attributeOptions?.includes(attr.type) && (
                                    <option value={attr.type}>{attr.type}</option>
                                )}
                                {attributeOptions?.map((option) => (
                                    <option key={option} value={option} disabled={attributes.some(a => a.type === option && a.type !== attr.type)}>
                                        {option}
                                    </option>
                                ))}
                            </select>
                        </label>

                        <div style={{ display: "block", marginTop: 10, width: '50%' }} className={styles.addCatLabel}>
                            Variation Value

                            <input
                                type="text"
                                placeholder="Enter value"
                                className={styles.addCatInput}
                                value={attr.values && attr.values.length > 0 ? attr.values.join(", ") : ""}
                                onChange={(e) => handleValueChange(index, e.target?.value)}
                            />

                        </div>


                        {attributes.length > 1 && (
                            <button
                                type="button"
                                className={styles.removeButton}
                                onClick={() => handleRemoveAttribute(index)}
                                style={{ border: 'none', borderRadius: 4, background: 'none' }}
                            >
                                <Delete />
                            </button>
                        )}
                    </div>
                ))}


                <button type="button" className={styles.addVar} onClick={handleAddAttribute}>
                    <Add /> Add Attribute
                </button>
            </div>
        </div>
    );
};

export default VariantsCard;
